module.exports = __webpack_public_path__ + "img/EBIKE_WORLD_FEDERATION_Logo.2469eb98.svg";